<template>
<v-dialog :value="value" fullscreen>
  <v-card height="100%" style="overflow-x: hidden">
    <v-row id="float-panel" class="float-panel-right">
      <v-col id="folder-select-section" cols="auto" align-self="center">
        <v-row>
          <v-col cols="auto" align-self="center">
            <v-btn fab color="rgba(0, 0, 0, 0.5)" small @click="previousFolderCompare(0)">
              <v-icon small color="white">
                mdi-less-than
              </v-icon>
            </v-btn>
          </v-col>
          <v-col cols="auto">
            <v-select
                dense
                dark
                hide-details="auto"
                v-model="selectedFolder"
                :items="folders"
                v-on:change="changeFolderCompare(0)"
            >
              <template v-slot:selection="data">
                <v-container class="py-0">
                  <v-row class="px-2">
                    {{ data.item.text.property.shooting_date ? data.item.text.property.shooting_date.split(' ')[0] : null }}
                  </v-row>
                  <v-row>
                    <v-chip
                        v-if="data.item.text.property.shooting_height"
                        x-small
                        class="ma-1"
                    >
                      {{ data.item.text.property.shooting_height }}m
                    </v-chip>
                    <v-chip
                        v-if="data.item.text.property.gimbal_angle"
                        x-small
                        class="ma-1"
                    >
                      {{ data.item.text.property.gimbal_angle }}°
                    </v-chip>
                    <v-chip
                        v-if="data.item.text.property.drone_type"
                        x-small
                        class="ma-1"
                    >
                      {{ data.item.text.property.drone_type }}
                    </v-chip>
                    <v-chip
                        v-if="
                      data.item.text.color_type == 'thermal' ||
                      data.item.text.color_type_count == 2
                    "
                        color="orange"
                        x-small
                        class="ma-1"
                    >
                      サーマル
                    </v-chip>
                    <v-chip
                        v-if="
                      data.item.text.color_type == 'color' ||
                      data.item.text.color_type_count == 2
                    "
                        color="green"
                        x-small
                        class="ma-1"
                    >
                      RGB
                    </v-chip>
                  </v-row>
                </v-container>
              </template>
              <template v-slot:item="data">
                <v-container>
                  <v-row class="px-2">
                    {{ data.item.text.property.shooting_date ? data.item.text.property.shooting_date.split(' ')[0] : null }}
                  </v-row>
                  <v-row>
                    <v-chip
                        v-if="data.item.text.property.shooting_height"
                        x-small
                        class="ma-1"
                    >
                      {{ data.item.text.property.shooting_height }}m
                    </v-chip>
                    <v-chip
                        v-if="data.item.text.property.gimbal_angle"
                        x-small
                        class="ma-1"
                    >
                      {{ data.item.text.property.gimbal_angle }}°
                    </v-chip>
                    <v-chip
                        v-if="data.item.text.property.drone_type"
                        x-small
                        class="ma-1"
                    >
                      {{ data.item.text.property.drone_type }}
                    </v-chip>
                    <v-chip
                        v-if="
                      data.item.text.color_type == 'thermal' ||
                      data.item.text.color_type_count == 2
                    "
                        color="orange"
                        x-small
                        class="ma-1"
                    >
                      サーマル
                    </v-chip>
                    <v-chip
                        v-if="
                      data.item.text.color_type == 'color' ||
                      data.item.text.color_type_count == 2
                    "
                        color="green"
                        x-small
                        class="ma-1"
                    >
                      RGB
                    </v-chip>
                  </v-row>
                </v-container>
              </template>
            </v-select>
          </v-col>
          <v-col cols="auto" align-self="center">
            <v-btn fab color="rgba(0, 0, 0, 0.5)" small @click="nextFolderCompare(0)">
              <v-icon small color="white">
                mdi-greater-than
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>

      <v-spacer></v-spacer>

      <v-col id="folder-select-section-second" cols="auto" align-self="center">
        <v-row>
          <v-col cols="auto" align-self="center">
            <v-btn fab color="rgba(0, 0, 0, 0.5)" small @click="previousFolderCompare(1)">
              <v-icon small color="white">
                mdi-less-than
              </v-icon>
            </v-btn>
          </v-col>
          <v-col cols="auto">
            <v-select
                dense
                dark
                hide-details="auto"
                v-model="secondFolderUuid"
                :items="folders"
                v-on:change="changeFolderCompare(1)"
            >
              <template v-slot:selection="data">
                <v-container class="py-0">
                  <v-row class="px-2">
                    {{ data.item.text.property.shooting_date ? data.item.text.property.shooting_date.split(' ')[0] : null }}
                  </v-row>
                  <v-row>
                    <v-chip
                        v-if="data.item.text.property.shooting_height"
                        x-small
                        class="ma-1"
                    >
                      {{ data.item.text.property.shooting_height }}m
                    </v-chip>
                    <v-chip
                        v-if="data.item.text.property.gimbal_angle"
                        x-small
                        class="ma-1"
                    >
                      {{ data.item.text.property.gimbal_angle }}°
                    </v-chip>
                    <v-chip
                        v-if="data.item.text.property.drone_type"
                        x-small
                        class="ma-1"
                    >
                      {{ data.item.text.property.drone_type }}
                    </v-chip>
                    <v-chip
                        v-if="
                        data.item.text.color_type == 'color' ||
                        data.item.text.color_type_count == 2
                      "
                        color="green"
                        x-small
                        class="ma-1"
                    >
                      RGB
                    </v-chip>
                    <v-chip
                        v-if="
                        data.item.text.color_type == 'thermal' ||
                        data.item.text.color_type_count == 2
                      "
                        color="orange"
                        x-small
                        class="ma-1"
                    >
                      サーマル
                    </v-chip>
                  </v-row>
                </v-container>
              </template>
              <template v-slot:item="data">
                <v-container>
                  <v-row class="px-2">
                    {{ data.item.text.property.shooting_date ? data.item.text.property.shooting_date.split(' ')[0] : null }}
                  </v-row>
                  <v-row>
                    <v-chip
                        v-if="data.item.text.property.shooting_height"
                        x-small
                        class="ma-1"
                    >
                      {{ data.item.text.property.shooting_height }}m
                    </v-chip>
                    <v-chip
                        v-if="data.item.text.property.gimbal_angle"
                        x-small
                        class="ma-1"
                    >
                      {{ data.item.text.property.gimbal_angle }}°
                    </v-chip>
                    <v-chip
                        v-if="data.item.text.property.drone_type"
                        x-small
                        class="ma-1"
                    >
                      {{ data.item.text.property.drone_type }}
                    </v-chip>
                    <v-chip
                        v-if="
                        data.item.text.color_type == 'color' ||
                        data.item.text.color_type_count == 2
                      "
                        color="green"
                        x-small
                        class="ma-1"
                    >
                      RGB
                    </v-chip>
                    <v-chip
                        v-if="
                        data.item.text.color_type == 'thermal' ||
                        data.item.text.color_type_count == 2
                      "
                        color="orange"
                        x-small
                        class="ma-1"
                    >
                      サーマル
                    </v-chip>
                  </v-row>
                </v-container>
              </template>
            </v-select>
          </v-col>
          <v-col cols="auto" align-self="center">
            <v-btn fab color="rgba(0, 0, 0, 0.5)" small @click="nextFolderCompare(1)">
              <v-icon small color="white">
                mdi-greater-than
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="auto" align-self="center">
        <v-btn fab color="rgba(0, 0, 0, 0.8)" @click="closeCompare">
          <v-icon color="rgb(255, 255, 255)">mdi-close</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-col style="height: 100%; padding: 0px;">
      <div ref="map_compare" id="map_compare"></div>
      <div id="comp-slider" ref="comp_slider">
        <div id="round-component" ref="round_component"></div>
        <div id="straight-component"></div>
      </div>
      <input id="swipe" ref="swipe" type="range" style="width: 100%" value="50" v-show="false">
    </v-col>
    <v-col cols="auto" id="dialog-navi-col" class="left-position" ref="dialog_navi_col">
      <div id="dialog-navi" ref="dialog_navi">
        <v-expansion-panels accordion tile multiple>
          <v-expansion-panel
              v-for="(item, i) in compareLayers"
              :key="i"
              :disabled="item.mapUrl === '' || item.disable"
          >
            <v-expansion-panel-header>
              <v-checkbox
                  v-model="item.visible"
                  :label="item.text"
                  @click="onChangeVisibleCompare($event, item, 0)"
                  hide-details="auto"
              ></v-checkbox>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-slider
                  v-model="item.transparency"
                  :max="100"
                  label="透明性"
                  class="align-center"
                  hide-details="auto"
                  @input="onChangeTransparencyCompare(item, 0)"
                  v-if="item.value != 'basic'"
              >
              </v-slider>
              <div v-if="item.value === 'basic'" class="ml-5">
                <v-checkbox
                    v-model="item.satellite.visible"
                    :label="item.satellite.text"
                    @click="onChangeVisibleCompare($event, item.satellite, 0)"
                    hide-details="auto"
                ></v-checkbox>
                <v-checkbox
                    v-model="item.openStreetMap.visible"
                    :label="item.openStreetMap.text"
                    @click="onChangeVisibleCompare($event, item.openStreetMap, 0)"
                    hide-details="auto"
                ></v-checkbox>
              </div>
              <div v-if="item.value === 'mask_annotation'">
                <div>
                  <v-row>
                    <v-card-text>
                      <v-radio-group v-model="version">
                        <v-radio
                            v-for="n in list_ai_versions"
                            :key="n.id"
                            :label="`Ver ${n.version}: ${n.description}`"
                            :value="n.version"
                            v-on:click="changeVersion(version)"
                        ></v-radio>
                      </v-radio-group>
                    </v-card-text>
                  </v-row>
                </div>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <v-btn x-small :class="value ? 'btn-left' : 'btn-origin-left'" height="67px" @click="hideBtnLeftCompare">
          <v-icon small v-if="hideLeft == value">mdi-less-than</v-icon>
          <v-icon small v-if="hideLeft != value">mdi-greater-than</v-icon>
        </v-btn>
      </div>
    </v-col>
    <v-col cols="auto" id="navi-col-second" class="right-position" ref="navi_col_second">
      <div id="navi-second" ref="navi_second">
        <v-expansion-panels accordion tile multiple>
          <v-expansion-panel
              v-for="(item, i) in mapComparison.layersSecond"
              :key="i"
              :disabled="item.mapUrl === '' || item.disable"
          >
            <v-expansion-panel-header>
              <v-checkbox
                  v-model="item.visible"
                  :label="item.text"
                  @click="onChangeVisibleCompare($event, item, 1)"
                  hide-details="auto"
              ></v-checkbox>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-slider
                  v-model="item.transparency"
                  :max="100"
                  label="透明性"
                  class="align-center"
                  hide-details="auto"
                  @input="onChangeTransparencyCompare(item, 1)"
                  v-if="item.value !== 'basic'"
              >
              </v-slider>
              <div v-if="item.value === 'basic'" class="ml-5">
                <v-checkbox
                    v-model="item.satellite.visible"
                    :label="item.satellite.text"
                    @click="onChangeVisibleCompare($event, item.satellite, 1)"
                    hide-details="auto"
                ></v-checkbox>
                <v-checkbox
                    v-model="item.openStreetMap.visible"
                    :label="item.openStreetMap.text"
                    @click="onChangeVisibleCompare($event, item.openStreetMap, 1)"
                    hide-details="auto"
                ></v-checkbox>
              </div>
              <div v-if="item.value === 'mask_annotation'">
                <div>
                  <v-row>
                    <v-card-text>
                      <v-radio-group v-model="version_compare">
                        <v-radio
                            v-for="n in mask_data_compare.list_version_compare"
                            :key="n.id"
                            :label="`Ver ${n.version}: ${n.description}`"
                            :value="n.version"
                            v-on:click="changeVersionCompare(version_compare)"
                        ></v-radio>
                      </v-radio-group>
                    </v-card-text>
                  </v-row>
                </div>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <v-btn x-small class="btn-right" height="67px" @click="hideBtnRightCompare">
          <v-icon small v-if="!hideRight">mdi-less-than</v-icon>
          <v-icon small v-if="hideRight">mdi-greater-than</v-icon>
        </v-btn>
      </div>
    </v-col>
  </v-card>
</v-dialog>
</template>

<script>
import Annotation from "@/utils/annotation";
import MapComparison from "@/utils/comparison";
import TileLayer from "ol/layer/Tile";
import XYZ from "ol/source/XYZ";
import LayerGroup from "ol/layer/Group";
import TileState from "ol/TileState";
import OSM from "ol/source/OSM";
import View from "ol/View";
import {store} from "@/store";
import Map from "ol/Map";
import {getRenderPixel} from "ol/render";

export default {
  name: "MapCompare",
  props: ['value', 'folderUuid', 'folders', 'layers', 'mapInitialPosition', 'annotationSource', 'changeFolder', 'getLayerById', 'getNaviLayerByValue'],
  data(){
    return {
      compareLayers: null,
      mapCompare: null,
      annotationCompare: new Annotation(),
      mapComparison: new MapComparison(),
      selectedFolder: this.folderUuid,
      secondFolderUuid: null,
      hideLeft: true,
      hideRight: true,
    }
  },
  methods: {
    initCompareMap(){
      this.resetLayersCompare();
      this.layers.forEach((layer) => {
        if (layer.value === "thermal" && layer.mapUrl !== ''){
          this.copyNaviLayer(layer);
        }
        if (layer.value === "color" && layer.mapUrl !== ''){
          this.copyNaviLayer(layer);
        }
      });
      this.mapCompare = new Map({
        target: this.$refs.map_compare,
        layers: [
          new LayerGroup({
            id: 'left',
            title: 'Left Layer',
            layers: [
              this.annotationCompare.annotationLayer,
              new TileLayer({
                id: 'thermal',
                zIndex: 3,
                opacity: this.getNaviLayerByValue( 'thermal', this.compareLayers).transparency,
                title: "サーマルオルソ画像",
                visible: this.getNaviLayerByValue( 'thermal', this.compareLayers).visible,
                extend: [
                  this.getNaviLayerByValue( 'thermal', this.compareLayers).bound1Lng,
                  this.getNaviLayerByValue( 'thermal', this.compareLayers).bound1Lat,
                  this.getNaviLayerByValue( 'thermal', this.compareLayers).bound2Lng,
                  this.getNaviLayerByValue( 'thermal', this.compareLayers).bound2Lat,
                ],
                source: new XYZ({
                  attributions: "",
                  url: this.getNaviLayerByValue( 'thermal', this.compareLayers).mapUrl,
                  tileSize: [256, 256],
                }),
              }),
              new TileLayer({
                id: 'color',
                zIndex: 2,
                opacity: this.getNaviLayerByValue( 'color', this.compareLayers).transparency,
                visible: this.getNaviLayerByValue( 'color', this.compareLayers).visible,
                title: "RGBオルソ画像",
                extend: [
                  this.getNaviLayerByValue( 'color', this.compareLayers).bound1Lng,
                  this.getNaviLayerByValue( 'color', this.compareLayers).bound1Lat,
                  this.getNaviLayerByValue( 'color', this.compareLayers).bound2Lng,
                  this.getNaviLayerByValue( 'color', this.compareLayers).bound2Lat,
                ],
                source: new XYZ({
                  attributions: "",
                  url: this.getNaviLayerByValue( 'color', this.compareLayers).mapUrl,
                  tileSize: [256, 256],
                }),
              }),
              new LayerGroup({
                id: 'basic',
                layers: [
                  new TileLayer({
                    id: 'Satellite',
                    zIndex: 1,
                    title: "Satellite",
                    opacity: this.getNaviLayerByValue( 'basic', this.compareLayers).satellite.transparency,
                    visible: this.getNaviLayerByValue( 'basic', this.compareLayers).satellite.visible,
                    source: new OSM({
                      minZoom: 17,
                      maxZoom: 17,
                      url: '/api/tiles/{z}/{x}/{y}',
                      tileLoadFunction: (tile, src) => {
                        const xhr = new XMLHttpRequest();
                        xhr.responseType = 'blob';
                        xhr.addEventListener('loadend', function () {
                          const data = this.response;
                          if (data !== undefined) {
                            tile.getImage().src = URL.createObjectURL(data);
                          } else {
                            tile.setState(TileState.ERROR);
                          }
                        });
                        xhr.addEventListener('error', function () {
                          tile.setState(TileState.ERROR);
                        });
                        xhr.open('GET', src);
                        xhr.setRequestHeader('Authorization', `Bearer ${store.state.token}`);
                        xhr.send();
                      }
                    }),
                  }),
                  new TileLayer({
                    id: 'OpenStreetMap',
                    zIndex: 0,
                    title: "OpenStreetMap",
                    opacity: this.getNaviLayerByValue( 'basic', this.compareLayers).openStreetMap.transparency,
                    visible: this.getNaviLayerByValue( 'basic', this.compareLayers).openStreetMap.visible,
                    source: new OSM(),
                  }),
                ]
              }),
            ]
          }),
          this.mapComparison.rightMapLayer,
        ],

        view: new View({
          minZoom: 17,
          maxZoom: 23,
          zoom: 17,
          center: [
            (this.mapInitialPosition.bound_1_lng +
                this.mapInitialPosition.bound_2_lng) /
            2,
            (this.mapInitialPosition.bound_1_lat +
                this.mapInitialPosition.bound_2_lat) /
            2,
          ],
        }),
      });
      const mapExtent = [
        this.mapInitialPosition.bound_1_lng - 1000,
        this.mapInitialPosition.bound_1_lat - 1000,
        this.mapInitialPosition.bound_2_lng + 1000,
        this.mapInitialPosition.bound_2_lat + 1000,
      ];

      const screenExtent = this.mapCompare.getView().calculateExtent();
      mapExtent.forEach((position, index) => {
        if (position < screenExtent[index] && index >= 2) {
          mapExtent[index] = screenExtent[index];
        }
        if (position > screenExtent[index] && index <= 1) {
          mapExtent[index] = screenExtent[index];
        }
      });

      this.mapCompare.setView(new View({
        minZoom: 17,
        maxZoom: 23,
        zoom: 17,
        center: [
          (this.mapInitialPosition.bound_1_lng +
              this.mapInitialPosition.bound_2_lng) /
          2,
          (this.mapInitialPosition.bound_1_lat +
              this.mapInitialPosition.bound_2_lat) /
          2,
        ],
        extent: mapExtent,
      }));
      this.mapCompare.getView().setZoom(18);
      this.mapCompare
          .getView()
          .fit([
            this.mapInitialPosition.bound_1_lng,
            this.mapInitialPosition.bound_1_lat,
            this.mapInitialPosition.bound_2_lng,
            this.mapInitialPosition.bound_2_lat,
          ]);

      // this.translateLayerCompare('color', 0);
      // this.translateLayerCompare('thermal', 0);

      this.mapComparison.init(this.mapCompare, this.$refs.swipe, (mapIndex, swipe, leftMap) => this.rerenderMap(mapIndex, swipe, leftMap), (layer, mapIndex) => this.translateLayerCompare(layer, mapIndex));
      this.annotationCompare.setMap(this.mapCompare);
      this.annotationCompare.annotationLayer.setSource(this.annotationSource);
    },
    openCompare(){
      this.mapCompare.removeInteraction(this.annotationCompare.modify);
      const currentPos = this.folders.findIndex((folder) => {
        return folder.value === this.selectedFolder;
      });

      if (currentPos === 0) {
        this.secondFolderUuid = this.folders[(currentPos + 1)%this.folders.length].value;
      } else {
        this.secondFolderUuid = this.folders[0].value;
      }

      this.axios
          .get("/api/map/" + this.secondFolderUuid)
          .then((response) => {
            this.mapComparison.updateLayersSecond(response.data);
            this.mapComparison.addEventToRightLayer();
            this.mapComparison.setAnnotationSource(response.data.annotation);
          });

      const slider = this.$refs.comp_slider;
      const swipe = this.$refs.swipe;
      const m = this.$refs.map_compare;
      const roundComponent = this.$refs.round_component;

      const initSlider = () => {
        slider.style.left = m.clientWidth * swipe.value / 100 - (slider.offsetWidth / 2) + 'px';
        roundComponent.style.top = (m.clientHeight / 2) - (roundComponent.offsetHeight / 2) + "px";
        this.mapCompare.render();
      }

      initSlider();

      let clicked = 0;

      const getCursorPos = (e) => {
        e = e || window.event;
        const a = m.getBoundingClientRect();
        return e.pageX - a.left - window.pageXOffset;
      }

      const slideMove = (e) => {
        if (clicked === 0) return false;
        let pos = getCursorPos(e);
        if (pos < 0) pos = 0;
        if (pos > m.clientWidth) pos = m.clientWidth;
        swipe.value = pos / m.clientWidth * 100;
        slider.style.left = m.clientWidth * swipe.value / 100 - (slider.offsetWidth / 2) + 'px';

        this.mapCompare.render();
      }

      const slideReady = (e) => {
        e.preventDefault();
        clicked = 1;
        window.addEventListener("mousemove", slideMove);
        window.addEventListener("touchmove", slideMove);
      }

      const slideFinish = () => {
        clicked = 0;
      }

      slider.addEventListener('mousedown', slideReady);
      window.addEventListener("mouseup", slideFinish);
      slider.addEventListener("touchstart", slideReady);
      window.addEventListener("touchend", slideFinish);

      window.onresize = initSlider;
      this.rerenderMap(0, swipe, true);

      this.mapCompare.updateSize();
    },
    rerenderMap(mapIndex, swipe, leftMap){
      this.mapCompare.getLayers().getArray()[mapIndex].getLayers().getArray().forEach((layer) => {
        if (layer.get('id') === 'basic' || layer.get('id') === 'mask_annotation'){
          layer.getLayers().getArray().forEach((layer) => {
            this.addEventOnLayer(layer, swipe, leftMap);
          });
        }
        else{
          this.addEventOnLayer(layer, swipe, leftMap);
        }
      });
    },
    addEventOnLayer(layer, swipe, leftMap){
      layer.on('prerender', (event) => {
        const ctx = event.context;
        const mapSize = this.mapCompare.getSize();
        const width = mapSize[0] * (swipe.value / 100);
        let tl = null, tr = null, bl = null, br = null;
        if (leftMap){
          tl = getRenderPixel(event, [0, 0]);
          tr = getRenderPixel(event, [width, 0]);
          bl = getRenderPixel(event, [0, mapSize[1]]);
          br = getRenderPixel(event, [width, mapSize[1]]);
        }
        else{
          tl = getRenderPixel(event, [width, 0]);
          tr = getRenderPixel(event, [mapSize[0], 0]);
          bl = getRenderPixel(event, [width, mapSize[1]]);
          br = getRenderPixel(event, mapSize);
        }

        ctx.save();
        ctx.beginPath();
        ctx.moveTo(tl[0], tl[1]);
        ctx.lineTo(bl[0], bl[1]);
        ctx.lineTo(br[0], br[1]);
        ctx.lineTo(tr[0], tr[1]);
        ctx.closePath();
        ctx.clip();
      });

      layer.on('postrender', (event) => {
        const ctx = event.context;
        ctx.restore();
      });
    },
    resetLayersCompare() {
      this.compareLayers = [
        {
          text: "アノテーション",
          value: "annotation",
          transparency: 100,
          visible: true,
        },
        {
          text: "サーマルオルソ画像",
          value: "thermal",
          transparency: 100,
          visible: false,
          mapUrl: "",
          bound1Lng: 0,
          bound1Lat: 0,
          bound2Lng: 0,
          bound2Lat: 0,
          lat_translate: 0,
          lng_translate: 0,
        },
        {
          text: "RGBオルソ画像",
          value: "color",
          transparency: 100,
          visible: false,
          mapUrl: "",
          bound1Lng: 0,
          bound1Lat: 0,
          bound2Lng: 0,
          bound2Lat: 0,
          lat_translate: 0,
          lng_translate: 0,
        },
        {
          openStreetMap: {
            transparency: 100,
            visible: true,
            text: "OpenStreetMap",
            value: 'OpenStreetMap',
          },
          satellite: {
            transparency: 100,
            visible: true,
            text: "Mapbox",
            value: 'Satellite',
          },
          visible: true,
          text: "ベースマップ",
          value: "basic",
        },
      ];
    },
    setMapLayerLocation(layer, ddMapPlan) {
      layer.mapUrl = ddMapPlan.path;
      layer.bound1Lng = ddMapPlan.bound_1_lng;
      layer.bound1Lat = ddMapPlan.bound_1_lat;
      layer.bound2Lng = ddMapPlan.bound_2_lng;
      layer.bound2Lat = ddMapPlan.bound_2_lat;
      layer.lat_translate = ddMapPlan.lat_translate;
      layer.lng_translate = ddMapPlan.lng_translate;
      layer.visible = true;
    },
    changeFolderCompare(mapLayerIndex){
      if (mapLayerIndex === 0) {
        this.resetLayersCompare();
        this.axios.get("/api/map/" + this.selectedFolder).then((response) => {
          if (response.data["color"]) {
            this.setMapLayerLocation(this.getNaviLayerByValue( 'color', this.compareLayers), response.data["color"]);
          }
          if (response.data["thermal"]) {
            this.setMapLayerLocation(this.getNaviLayerByValue( 'thermal', this.compareLayers), response.data["thermal"]);
          }
          const mapInitialPosition = JSON.parse(JSON.stringify(response.data["color"] ? response.data["color"] : response.data["thermal"]));
          this.mapCompare
              .getView()
              .setCenter([
                (mapInitialPosition.bound_1_lng +
                    mapInitialPosition.bound_2_lng) /
                2,
                (mapInitialPosition.bound_1_lat +
                    mapInitialPosition.bound_2_lat) /
                2,
              ]);
          this.mapCompare
              .getView()
              .fit([
                mapInitialPosition.bound_1_lng,
                mapInitialPosition.bound_1_lat,
                mapInitialPosition.bound_2_lng,
                mapInitialPosition.bound_2_lat,
              ]);
          this.changeMapLayer(this.getLayerById('color', this.mapCompare.getLayers().getArray()[0]), this.getNaviLayerByValue( 'color', this.compareLayers));
          this.changeMapLayer(this.getLayerById('thermal', this.mapCompare.getLayers().getArray()[0]), this.getNaviLayerByValue( 'thermal', this.compareLayers));
          this.annotationCompare.setSourceForCompare(response.data.annotation);
        });
        this.$emit('changeFolder', this.selectedFolder);
      } else {
        this.mapComparison.resetLayersSecond();

        this.axios
            .get("/api/map/" + this.secondFolderUuid)
            .then((response) => {
              this.mapComparison.updateLayersSecond(response.data);
              this.mapComparison.setAnnotationSource(response.data.annotation);
            });
      }
    },
    changeMapLayer(mapLayer, layer) {
      mapLayer.setSource(new XYZ({
        maxZoom: layer.maxZoom,
        minZoom: 17,
        attributions: "",
        url: layer.mapUrl,
        tileSize: [256, 256],
      }));
      mapLayer.setExtent([
        layer.bound1Lng,
        layer.bound1Lat,
        layer.bound2Lng,
        layer.bound2Lat,
      ]);
      mapLayer.setVisible(layer.visible);
      mapLayer.setOpacity(layer.transparency);
    },
    previousFolderCompare(mapLayerIndex){
      const currentPos = this.folders.findIndex((folder) => {
        if (mapLayerIndex === 0) return folder.value === this.selectedFolder;
        if (mapLayerIndex === 1) return folder.value === this.secondFolderUuid;
      });
      if (currentPos !== this.folders.length - 1) {
        if (mapLayerIndex === 0) this.selectedFolder = this.folders[currentPos + 1].value;
        if (mapLayerIndex === 1) this.secondFolderUuid = this.folders[currentPos + 1].value;
        this.changeFolderCompare(mapLayerIndex);
      }
    },
    nextFolderCompare(mapLayerIndex){
      const currentPos = this.folders.findIndex((folder) => {
        if (mapLayerIndex === 0) return folder.value === this.selectedFolder;
        if (mapLayerIndex === 1) return folder.value === this.secondFolderUuid;
      });
      if (currentPos > 0) {
        if (mapLayerIndex === 0) this.selectedFolder = this.folders[currentPos - 1].value;
        if (mapLayerIndex === 1) this.secondFolderUuid = this.folders[currentPos - 1].value;
        this.changeFolderCompare(mapLayerIndex);
      }
    },
    closeCompare(){
      // store.updateOpenDialog(false);
      this.$emit("input");
    },
    hideBtnLeftCompare() {
      switch (this.hideLeft) {
        case true: {
          this.$refs.dialog_navi_col.classList.add('hide-btn-left');
          if (this.$refs.dialog_navi_col.classList.contains('unhide-btn-left')) {
            this.$refs.dialog_navi_col.classList.remove('unhide-btn-left');
          }
          break;
        }
        case false: {
          this.$refs.dialog_navi_col.classList.add('unhide-btn-left');
          if (this.$refs.dialog_navi_col.classList.contains('hide-btn-left')) {
            this.$refs.dialog_navi_col.classList.remove('hide-btn-left');
          }
          break;
        }
      }
      this.hideLeft = !this.hideLeft;
    },
    hideBtnRightCompare() {
      switch (this.hideRight) {
        case true: {
          this.$refs.navi_col_second.classList.add('hide-btn-right');
          if (this.$refs.navi_col_second.classList.contains('unhide-btn-right')) {
            this.$refs.navi_col_second.classList.remove('unhide-btn-right');
          }
          break;
        }
        case false: {
          this.$refs.navi_col_second.classList.add('unhide-btn-right');
          if (this.$refs.navi_col_second.classList.contains('hide-btn-right')) {
            this.$refs.navi_col_second.classList.remove('hide-btn-right');
          }
          break;
        }
      }
      this.hideRight = !this.hideRight;
    },
    copyNaviLayer(layer){
      this.getNaviLayerByValue( layer.value, this.compareLayers).transparency = 100;
      this.getNaviLayerByValue( layer.value, this.compareLayers).visible = true;
      this.getNaviLayerByValue( layer.value, this.compareLayers).mapUrl = layer.mapUrl;
      this.getNaviLayerByValue( layer.value, this.compareLayers).bound1Lng = layer.bound1Lng;
      this.getNaviLayerByValue( layer.value, this.compareLayers).bound1Lat = layer.bound1Lat;
      this.getNaviLayerByValue( layer.value, this.compareLayers).bound2Lng = layer.bound2Lng;
      this.getNaviLayerByValue( layer.value, this.compareLayers).bound2Lat = layer.bound2Lat;
      this.getNaviLayerByValue( layer.value, this.compareLayers).lat_translate = layer.lat_translate;
      this.getNaviLayerByValue( layer.value, this.compareLayers).lng_translate = layer.lng_translate;
    },
    onChangeVisibleCompare(event, layer, mapLayerIndex) {
      const mapLayer = this.getLayerById(layer.value, this.mapCompare.getLayers().getArray()[mapLayerIndex]);
      if (mapLayer){
        mapLayer.setVisible(layer.visible);
      }
      switch (layer.value){
        case 'Satellite':
        case 'OpenStreetMap': {
          let naviLayer = null;
          if (mapLayerIndex == 0){
            naviLayer = this.getNaviLayerByValue('basic', this.compareLayers);
          }
          else {
            naviLayer = this.getNaviLayerByValue('basic', this.mapComparison.layersSecond);
          }
          naviLayer.visible = naviLayer.openStreetMap.visible || naviLayer.satellite.visible;
          this.getLayerById('basic', this.mapCompare.getLayers().getArray()[mapLayerIndex]).setVisible(naviLayer.visible);
          break;
        }
        case 'basic': {
          layer.openStreetMap.visible = layer.visible;
          layer.satellite.visible = layer.visible;
          this.getLayerById(layer.openStreetMap.value, this.mapCompare.getLayers().getArray()[mapLayerIndex]).setVisible(layer.visible);
          this.getLayerById(layer.satellite.value, this.mapCompare.getLayers().getArray()[mapLayerIndex]).setVisible(layer.visible);
          break;
        }
        case 'annotation':{
          this.changeAnnotationModeCompare('none');
          break;
        }
      }

      event.cancelBubble = true;
    },
    changeAnnotationModeCompare(mode) {
      this.annotationCompare.mode = mode;
      if (this.annotationCompare.mode !== "add") {
        this.mapCompare.removeInteraction(this.annotationCompare.draw);
      }
    },
    onChangeTransparencyCompare(layer, mapLayerIndex) {
      this.getLayerById(layer.value, this.mapCompare.getLayers().getArray()[mapLayerIndex]).setOpacity(layer.transparency / 100);
    },
  },

  mounted() {
    this.initCompareMap();
    this.openCompare();
  }
}
</script>

<style scoped>
#map_compare{
  width: 100%;
  height: 100%;
}

#dialog-navi {
  border-left: 1px solid #ccc;
  width: auto;
}

#dialog-navi .v-expansion-panel-header {
  font-weight: 600;
}

#dialog-navi .v-input--selection-controls {
  margin-top: 0px;
  padding-top: 0px;
}

#navi-second {
  border-left: 1px solid #ccc;
  width: auto;
  height: 100%;
}

#navi-second .v-expansion-panel-header {
  font-weight: 600;
}

#navi-second .v-input--selection-controls {
  margin-top: 0px;
  padding-top: 0px;
}

.v-expansion-panel-header {
  padding: 12px 10px;
}

#dialog-navi .theme--light.v-expansion-panels .v-expansion-panel--disabled {
  background-color: #ccc;
}

#dialog-navi .v-expansion-panels {
  width: 280px;
}

#navi-second .v-expansion-panels {
  width: 280px;
}

#navi-second .theme--light.v-expansion-panels .v-expansion-panel--disabled {
  background-color: #ccc;
}

.left-position {
  position: absolute;
  left: 0px;
  top: 150px;
  padding: 0;
}

.right-position {
  position: absolute;
  right: 0px;
  top: 150px;
  padding: 0;
}

#float-panel {
  position: absolute;
  top: 10px;
  left: 22px;
  z-index: 1;
  border-radius: 4px;
  color: white;
}

.float-panel-right {
  right: 20px;
}

#folder-select-section {
  background: rgba(0, 0, 0, 0.8);
  border-radius: 4px;
  width: auto;
  padding-bottom: 0;
  padding-top: 0;
}

#folder-select-section-second {
  background: rgba(0, 0, 0, 0.8);
  border-radius: 4px;
  width: auto;
  right: 0px;
  padding-bottom: 0;
  padding-top: 0;
}

#comp-slider {
  position: absolute;
  top: 0px;
  z-index: 9;
  cursor: ew-resize;
  opacity: 0.7;
  border-radius: 50%;
  height: 100%;
}

#round-component {
  position: absolute;
  border-radius: 50%;
  left: -20px;
  width: 40px;
  height: 40px;
  background-color: #2196f3;
}

#straight-component {
  position: absolute;
  top: 0px;
  left: -2px;
  width: 4px;
  height: 100%;
  background-color: #2196f3;
}

.btn-left {
  position: absolute;
  left: 280px;
  top: 38%;
}

.btn-right {
  position: absolute;
  right: 280px;
  top: 38%;
}

.btn-origin-left {
  position: absolute;
  right: 280px;
  top: 38%;
}

>>>.ol-zoom {
  top: auto;
  bottom: 0.5em;
}

@keyframes hide-btn-left {
  from {
    left: 0;
  }
  to {
    left: -280px;
  }
}

.hide-btn-left {
  left: -280px;
  animation: hide-btn-left;
  animation-duration: 0.5s;
  animation-delay: 0s;
}

@keyframes unhide-btn-left {
  from {
    left: -280px;
  }
  to {
    left: 0;
  }
}

.unhide-btn-left {
  left: 0;
  animation: unhide-btn-left;
  animation-duration: 0.5s;
  animation-delay: 0s;
}

@keyframes hide-btn-right {
  from {
    right: 0;
  }
  to {
    right: -280px
  }
}

.hide-btn-right {
  right: -280px;
  animation: hide-btn-right;
  animation-duration: 0.5s;
  animation-delay: 0s;
}

@keyframes unhide-btn-right {
  from {
    right: -280px;
  }
  to {
    right: 0;
  }
}

.unhide-btn-right {
  right: 0;
  animation: unhide-btn-right;
  animation-duration: 0.5s;
  animation-delay: 0s;
}

>>>.v-text-field .v-select__selections > input {
  width: 0px;
}
</style>
